module.exports = "https://portperrypedals.ca/_res/img/focus.f94856f.gif";